import { ShortBreakMode } from 'app/constants/configuration/shortBreakMode'

export const getShortBreakModeName = (
  shortBreakMode: ShortBreakMode,
  translate: (string) => string,
): string => {
  const text: string = ShortBreakMode[shortBreakMode]
  return translate(`shortBreakMode.${text}`)
}
